import { CHANNEL_INTERFACE_TYPE } from '@/enums';

/** 授权类型 */
export const AUTH_TYPE = {
  LINK: 'link', // 链接授权
  AUTO: 'auto', // 自动授权
  ADVERTISER_ID: 'advertiser_id', // 广告主ID授权
};

/**
 * 页面配置
 * @typedef {Object} PageConfig
 * @property {string} channel_interface 渠道接口
 * @property {string} auth_type 授权类型
 * @property {Object} [form_item_tips] 表单项提示文案 - 键值为表单项键值
 * @property {string[]} [md5_fields] 提交时需 md5 加密的表单项键值 - 编辑时值未变更则不重复加密
 */

/**
 * 获取表单项提示文案
 * @param {PageConfig} page_config 页面配置
 * @param {string} key 表单项键值
 * @returns {string | undefined} 表单项提示文案
 */
export function getFormItemTips(page_config = {}, key) {
  const tips = page_config.form_item_tips || {};

  return tips[key];
}

/**
 * 表单项是否需要 md5 加密
 * @param {PageConfig} page_config 页面配置
 * @param {string} key 表单项键值
 * @returns {boolean} 是否需要 md5 加密
 */
export function isMd5Field(page_config = {}, key) {
  const md5_fields = page_config.md5_fields || [];

  return md5_fields.indexOf(key) !== -1;
}

/**
 * 根据权限获取页面配置
 * @param {string} permission 页面权限值
 * @returns {PageConfig}
 */
export function getPageConfig(permission) {
  const base_key = 'put-in-setting';
  const config = {
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.JRTT}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.JRTT,
      auth_type: AUTH_TYPE.LINK,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.GDT}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.GDT,
      auth_type: AUTH_TYPE.LINK,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.BAIDU}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.BAIDU,
      auth_type: AUTH_TYPE.LINK,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.BILIBILI}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.BILIBILI,
      auth_type: AUTH_TYPE.AUTO,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.KUAISHOU}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.KUAISHOU,
      auth_type: AUTH_TYPE.LINK,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.HUAWEI}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.HUAWEI,
      auth_type: AUTH_TYPE.LINK,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.OPPO}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.OPPO,
      auth_type: AUTH_TYPE.ADVERTISER_ID,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.VIVO}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.VIVO,
      auth_type: AUTH_TYPE.LINK,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.XIAOMI}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.XIAOMI,
      auth_type: AUTH_TYPE.ADVERTISER_ID,
    },
    [`${base_key}-${CHANNEL_INTERFACE_TYPE.YIXIAO}`]: {
      channel_interface: CHANNEL_INTERFACE_TYPE.YIXIAO,
      auth_type: AUTH_TYPE.ADVERTISER_ID,
      md5_fields: ['secret'],
      form_item_tips: {
        app_id: '填写易效的客户 ID',
        secret: '填写易效的登录密码',
        advertiser_id: '填写易效的客户 ID',
      },
    },
  };
  return config[permission] || config[`${base_key}-${CHANNEL_INTERFACE_TYPE.JRTT}`];
}
